import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CheerioButton from "../../../Components/CheerioButton";
import images from '../../../Utils/images';
import '../styles.css';

export default function WhatsAppSetupModal({
  setSetupComplete,
  setupComplete,
}) {
  const modalRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setSetupComplete(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setSetupComplete]);

  return (
    <div className="wa-modal-overlay" onClick={() => setSetupComplete(false)}>
      <div
        ref={modalRef}
        className="wa-modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={images.CMClose}
          alt="Close"
          className="wa-close-button"
          onClick={() => setSetupComplete(false)}
        />

        <div className="wa-image-wrapper">
          <img
            src={images.CATSuccess}
            alt="Success"
            className="wa-success-image"
          />
        </div>

        <h2 className="wa-title">WhatsApp setup completed</h2>
        <p className="wa-description">
          Congratulations! You can now test webhooks by sending a WhatsApp message to your number.
        </p>

        <CheerioButton
          btnText="Test Webhooks"
          backColor="#8E53F7"
          textStyle={{ color: 'white', fontWeight: 500 }}
          borderStyle={{ border: 'none' }}
          onclick={() => {
            navigate('/creator/whatsappreplies');
            setSetupComplete(false);
          }}
        />
      </div>
    </div>
  );
}